/**
 * Flow Type Mapping System
 *
 * Single source of truth mapping backend flow types to UI/feature names.
 * Only define mappings where they differ - same names are automatically handled.
 *
 * Backend flow_type: Used in API payloads, database, pipeline processing
 * UI/Feature names: Used in routes, feature flags, org.features_enabled
 */

// ============================================================================
// SINGLE SOURCE OF TRUTH: Backend → UI Mapping
// ============================================================================

/**
 * Only define mappings where backend and UI names differ.
 * If not listed here, assume backend and UI names are the same.
 */
const BACKEND_TO_UI_MAPPING: Record<string, string> = {
  // Backend → UI (only where different)
  rag: 'genai_rag',
  custom: 'byo',
  in_memory: 'directflow',
};

// ============================================================================
// HELPER FUNCTIONS (Reverse mapping is auto-generated)
// ============================================================================

/**
 * Converts backend flow_type to UI/feature name
 * Use when checking feature flags or org.features_enabled
 */
export function toUIFlowType(backendFlowType: string): string {
  return BACKEND_TO_UI_MAPPING[backendFlowType] || backendFlowType;
}

/**
 * Converts UI/feature name to backend flow_type
 * Use when creating API payloads or updating flow_type field
 */
export function toBackendFlowType(uiFlowType: string): string {
  // Reverse lookup - find backend key for UI value
  const entry = Object.entries(BACKEND_TO_UI_MAPPING).find(([_, ui]) => ui === uiFlowType);
  return entry ? entry[0] : uiFlowType;
}
